module.exports = __webpack_public_path__ + "static/0333-5b6ffba572ed01c08a111bb8fbfe651d.svg";